<template>
  <div class="c--partner-with-us_airalo-affiliate-partners-have-to-say new-container mx-auto">
    <div class="airalo-affiliate-partners-have-to-say my-20 my-md-30 my-lg-40">
      <h1 v-if="title" class="have-to-say-title">
        {{ title }}
      </h1>
      <div v-if="false" class="have-to-say-boxes">
        <div
          v-for="(item, index) in haveToSayItems"
          :key="`have-to-say-boxes-item-${index}`"
          class="have-to-say-boxes-item"
        >
          <img :src="item.img" alt width="160" height="160" loading="lazy" />
          <h3>{{ item.name }}</h3>
          <p>{{ item.companyName }}</p>
          <span>{{ item.type }}</span>
        </div>
      </div>
      <a
        target="_blank"
        :href="joinUsURL"
        class="join-us-btn call-to-action dark no-outline btn-primary-hv tw-flex tw-justify-center tw-items-center hover:tw-no-underline"
        @click="sendEventHandler(joinUsURL)"
      >
        {{ $t('scenes.airalo.partner.hub.join-us-button-title') }}
      </a>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'airalo-affiliate-partners-have-to-say',

    props: {
      title: {
        type: String,
        required: false,
        default: null,
      },
      joinUsType: {
        type: String,
        required: false,
      },
    },

    data() {
      return {
        haveToSayItems: [
          {
            name: this.$t('components.partner.with.us.affiliate.partners.says.person-name-1'),
            companyName: this.$t('components.partner.with.us.affiliate.partners.says.company-name-1'),
            type: this.$t('components.partner.with.us.affiliate.partners.says.partnership-type-1'),
            img: `/assets/images/partner-with-us/${this.joinUsType}-have-to-say-1.png`,
          },
          {
            name: this.$t('components.partner.with.us.affiliate.partners.says.person-name-2'),
            companyName: this.$t('components.partner.with.us.affiliate.partners.says.company-name-2'),
            type: this.$t('components.partner.with.us.affiliate.partners.says.partnership-type-2'),
            img: `/assets/images/partner-with-us/${this.joinUsType}-have-to-say-2.png`,
          },
          {
            name: this.$t('components.partner.with.us.affiliate.partners.says.person-name-3'),
            companyName: this.$t('components.partner.with.us.affiliate.partners.says.company-name-3'),
            type: this.$t('components.partner.with.us.affiliate.partners.says.partnership-type-3'),
            img: `/assets/images/partner-with-us/${this.joinUsType}-have-to-say-3.png`,
          },
        ],
      }
    },

    methods: {
      sendEventHandler(payload) {
        this.$utils.sendEvent('ctaClick', {
          text: this.$t('scenes.airalo.partner.hub.join-us-button-title'),
          url: payload,
        })
      },
    },

    computed: {
      joinUsURL() {
        const partnersPlatformOnboardingUrl = 'https://partners.airalo.com/sign-up/onboarding'

        switch (this.joinUsType) {
          case 'affiliate-partners':
            return this.$t('url.airalo.partner.with.us.affiliate-impact')
          case 'distribution_partner':
            return `${partnersPlatformOnboardingUrl}/reseller-pp`
          case 'corporate':
            return `${partnersPlatformOnboardingUrl}/corporate`
          case 'api_partner':
            return `${partnersPlatformOnboardingUrl}/reseller-api`
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
  .airalo-affiliate-partners-have-to-say {
    display: flex;
    flex-direction: column;
    padding: 0;

    .have-to-say-title {
      color: #4a4a4a;
      font-size: 27px;
      font-weight: 600;
      letter-spacing: -0.5px;
      line-height: 32px;
      text-align: center;
      margin-bottom: 40px;
    }

    .have-to-say-boxes {
      display: grid;
      gap: 30px;
      grid-template-columns: repeat(3, minmax(0, 1fr));

      &-item {
        min-width: 225px;
        border-radius: 7px;
        background-color: #ffffff;
        box-shadow: 0 10px 30px 0 rgba(0, 0, 0, 0.15);
        padding: 40px 23px 40px 24px;
        align-items: center;
        text-align: center;

        img {
          margin-bottom: 20px;
        }

        h3 {
          color: #4a4a4a;
          font-size: 21px;
          font-weight: 600;
          letter-spacing: -0.3px;
          line-height: 25px;
          text-align: center;
          margin-bottom: 10px;
        }

        p {
          color: #8a8a8a;
          font-size: 13px;
          letter-spacing: 0;
          line-height: 18px;
          text-align: center;
          margin-bottom: 10px;
        }

        span {
          display: inline-flex;
          padding: 3px 10px;
          border-radius: 4px;
          background: linear-gradient(270deg, #f16b2e 0%, #ef5b76 100%);
          color: #ffffff;
          font-size: 11px;
          font-weight: 600;
          letter-spacing: 1px;
          line-height: 14px;
          text-align: center;
        }
      }
    }

    .join-us-btn {
      width: 350px;
      padding: 16px 20px 15px;
      color: #ffffff;
      font-size: 11px;
      font-weight: 600;
      letter-spacing: 1px;
      line-height: 11px;
      text-align: center;

      &:hover {
        text-decoration: none;
      }
    }
  }

  @media all and (max-width: 768px) {
    .airalo-affiliate-partners-have-to-say {
      .have-to-say-title {
        font-size: 21px;
        margin-bottom: 30px;
      }

      .have-to-say-boxes {
        grid-template-columns: repeat(2, minmax(0, 1fr));
      }

      .join-us-btn {
        margin-top: 30px;
      }
    }
  }
  @media only screen and (max-width: 567px) {
    .airalo-affiliate-partners-have-to-say {
      .have-to-say-title {
        margin-bottom: 20px;
      }

      .have-to-say-boxes {
        grid-template-columns: repeat(1, minmax(0, 1fr));
      }

      .join-us-btn {
        max-width: unset;
        width: 100%;
        margin-top: 20px;
      }
    }
  }
</style>
